export enum ValidationStatus {
  VALIDATING = 'validating',
  AUTHENTICATED = 'authenticated',
  NEEDS_LOGIN = 'needs-login',
  ERROR = 'error',
}
